import React from 'react';

import {useCharacter} from '../character-context';
import type {SpellListEntry} from '../model/spell-list';
import {byTitle} from './format';
import {SpellRow} from './spell-row';

import css from './sheet.module.css';

type Props = {
	entries: SpellListEntry[];
	/** показывать отметки подготовки */
	withPreparation?: boolean;
};

export const SpellList: React.FC<Props> = ({entries, withPreparation}) => {
	const {catalog} = useCharacter();
	const levelOf = (entry: SpellListEntry) => catalog.getSpell(entry.spell.id)?.level ?? 0;

	const entriesByLevel = new Map<number, SpellListEntry[]>();
	const titleOf = (entry: SpellListEntry) => catalog.getSpell(entry.spell.id)?.title || entry.spell.id;
	const sorted = [...entries].sort(
		(first, second) => levelOf(first) - levelOf(second) || byTitle(titleOf(first), titleOf(second)),
	);
	for (const entry of sorted) {
		entriesByLevel.set(levelOf(entry), [...(entriesByLevel.get(levelOf(entry)) || []), entry]);
	}

	return (
		<>
			{[...entriesByLevel].map(([level, levelEntries]) => (
				<div key={level}>
					<h3 className={css.groupTitle}>{level === 0 ? 'Фокусы' : `${level} круг`}</h3>
					<ul className={css.spellList}>
						{levelEntries.map((entry) => (
							<SpellRow key={entry.spell.id} entry={entry} withPreparation={withPreparation} />
						))}
					</ul>
				</div>
			))}
		</>
	);
};
